import { render, staticRenderFns } from "./ViewProductDiscount.vue?vue&type=template&id=386a1aa8&"
import script from "./ViewProductDiscount.vue?vue&type=script&lang=js&"
export * from "./ViewProductDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fod/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports